import { type } from 'arktype';

export const createPersonDefaultShiftSchema = type({
  shiftUnitId: type('string>=1').configure({
    description: 'ID of the shift unit to assign as default for this weekday.',
    examples: ['shift-unit-abc123'],
  }),
  weekday: type('0 | 1 | 2 | 3 | 4 | 5 | 6').configure({
    description: 'ISO weekday this pattern applies to (0=Mon … 6=Sun).',
    examples: [0],
  }),
  'validFrom?': type(/^\d{4}-\d{2}-\d{2}$/)
    .or('null')
    .configure({
      description: 'Inclusive start date (YYYY-MM-DD); null/omitted means open-start.',
      examples: [null],
    }),
  'validTo?': type(/^\d{4}-\d{2}-\d{2}$/)
    .or('null')
    .configure({
      description: 'Inclusive end date (YYYY-MM-DD); null means open-ended.',
      examples: [null],
    }),
}).configure({ description: 'Payload to create a person default shift pattern.' });

export type CreatePersonDefaultShift = typeof createPersonDefaultShiftSchema.t;

export const updatePersonDefaultShiftSchema = type({
  'shiftUnitId?': type('string>=1').configure({ description: 'Updated shift unit ID.' }),
  'weekday?': type('0 | 1 | 2 | 3 | 4 | 5 | 6').configure({ description: 'Updated ISO weekday (0=Mon … 6=Sun).' }),
  'validFrom?': type(/^\d{4}-\d{2}-\d{2}$/)
    .or('null')
    .configure({ description: 'Updated inclusive start date; null = open-start.' }),
  'validTo?': type(/^\d{4}-\d{2}-\d{2}$/)
    .or('null')
    .configure({ description: 'Updated inclusive end date; null = open-ended.' }),
}).configure({ description: 'Partial update of a person default shift pattern.' });

export type UpdatePersonDefaultShift = typeof updatePersonDefaultShiftSchema.t;

export interface PersonDefaultShiftResponse {
  id: string;
  personId: string;
  shiftUnitId: string;
  weekday: number;
  validFrom: string | null;
  validTo: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export type AssignmentSource = 'override' | 'template' | 'person_default';
/** date → personId → shiftUnitId → source */
export type ProvenanceMap = Record<string, Record<string, Record<string, AssignmentSource>>>;
